import { useState } from 'react'
import { Box, Typography, Paper, Collapse, IconButton } from '@mui/material'
import GoogleIcon from '../components/icon/GoogleIcon'

export default function SectionCard({
  title,
  icon = null,
  headerRight = null,
  sx = {},
  children,
  collapsible = false,
  showCollapseIcon = true,
  defaultOpen = true,
  onToggle = null
}) {
  const [open, setOpen] = useState(defaultOpen)

  const handleToggle = () => {
    if (!collapsible) return

    setOpen((prevOpen) => {
      const nextOpen = !prevOpen
      onToggle?.(nextOpen)
      return nextOpen
    })
  }

  const body = (
    <Box px={2} pb={2}>
      {children}
    </Box>
  )

  return (
    <Paper elevation={3} sx={{ p: 1, borderRadius: 3, mb: 3, ...sx }}>
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1.5,
            cursor: collapsible ? 'pointer' : 'default'
          }}
          onClick={handleToggle}
        >
          <Box display="flex" alignItems="center" gap={1}>
            {icon}
            <Typography fontWeight={700}>{title}</Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            {headerRight && <Box onClick={(event) => event.stopPropagation()}>{headerRight}</Box>}

            {collapsible && showCollapseIcon && (
              <IconButton
                size="small"
                onClick={(event) => {
                  event.stopPropagation()
                  handleToggle()
                }}
                aria-label={open ? 'Cerrar sección' : 'Abrir sección'}
              >
                <GoogleIcon name={open ? 'expand_less' : 'expand_more'} size={20} />
              </IconButton>
            )}
          </Box>
        </Box>

        {collapsible ? (
          <Collapse in={open} timeout="auto" unmountOnExit>
            {body}
          </Collapse>
        ) : (
          body
        )}
      </Box>
    </Paper>
  )
}
